/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HttpError } from '../model/httpError';
import { TaxRateBulkInsertInner } from '../model/taxRateBulkInsertInner';
import { TaxRateBulkInsertView } from '../model/taxRateBulkInsertView';
import { TaxRateBulkUpdateInner } from '../model/taxRateBulkUpdateInner';
import { TaxRateBulkUpdateView } from '../model/taxRateBulkUpdateView';
import { TaxRateInsert } from '../model/taxRateInsert';
import { TaxRateUpdate } from '../model/taxRateUpdate';
import { TaxRateView } from '../model/taxRateView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TaxRatesService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Creates multiple new TaxRate records&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesBulkInsertPost(body?: Array<TaxRateBulkInsertInner>, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaxRateBulkInsertView>>;
    public taxRatesBulkInsertPost(body?: Array<TaxRateBulkInsertInner>, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaxRateBulkInsertView>>>;
    public taxRatesBulkInsertPost(body?: Array<TaxRateBulkInsertInner>, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaxRateBulkInsertView>>>;
    public taxRatesBulkInsertPost(body?: Array<TaxRateBulkInsertInner>, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TaxRateBulkInsertView>>('post',`${this.basePath}/TaxRates/bulkInsert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Updates multiple TaxRate records&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesBulkUpdatePut(body?: Array<TaxRateBulkUpdateInner>, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaxRateBulkUpdateView>>;
    public taxRatesBulkUpdatePut(body?: Array<TaxRateBulkUpdateInner>, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaxRateBulkUpdateView>>>;
    public taxRatesBulkUpdatePut(body?: Array<TaxRateBulkUpdateInner>, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaxRateBulkUpdateView>>>;
    public taxRatesBulkUpdatePut(body?: Array<TaxRateBulkUpdateInner>, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TaxRateBulkUpdateView>>('put',`${this.basePath}/TaxRates/bulkUpdate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public taxRatesByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public taxRatesByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public taxRatesByExternalKeyIdDelete(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesByExternalKeyIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/TaxRates/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_taxrates
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<TaxRateView>;
    public taxRatesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaxRateView>>;
    public taxRatesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaxRateView>>;
    public taxRatesByExternalKeyIdGet(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesByExternalKeyIdGet.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TaxRateView>('get',`${this.basePath}/TaxRates/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesByExternalKeyIdPut(id: string, body?: TaxRateUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaxRateView>>;
    public taxRatesByExternalKeyIdPut(id: string, body?: TaxRateUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaxRateView>>>;
    public taxRatesByExternalKeyIdPut(id: string, body?: TaxRateUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaxRateView>>>;
    public taxRatesByExternalKeyIdPut(id: string, body?: TaxRateUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesByExternalKeyIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TaxRateView>>('put',`${this.basePath}/TaxRates/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for TaxRate objects&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_taxrates
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: orgRefId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: taxRateId, wholesaleTax0, wholesaleTax1, wholesaleTax2, wholesaleTax3, salesTax0, salesTax1, salesTax2, salesTax3, qtyTaxFree, orgRefId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: taxRateId, wholesaleTax0, wholesaleTax1, wholesaleTax2, wholesaleTax3, salesTax0, salesTax1, salesTax2, salesTax3, qtyTaxFree, orgRefId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is taxRateId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - taxRateId would sort by updateDateTime ascending and then taxRateId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param taxRateId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the taxRateId field and returns all available results that match.   You can use &gt;10 to search for all taxRateIds greater than 10. You can use [1,2,3] to search for taxRateIds that match either 1, 2 or 3. You can use this parameter multiple times. eg taxRateId&#x3D;&gt;5&amp; taxRateId&#x3D;&lt;10 would search for all taxRateIds between 5 and 10.
     * @param wholesaleTax0 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the wholesaleTax0 field and returns all available results that match.   You can use &gt;10 to search for all wholesaleTax0s greater than 10. You can use [1,2,3] to search for wholesaleTax0s that match either 1, 2 or 3. You can use this parameter multiple times. eg wholesaleTax0&#x3D;&gt;5&amp; wholesaleTax0&#x3D;&lt;10 would search for all wholesaleTax0s between 5 and 10.
     * @param wholesaleTax1 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the wholesaleTax1 field and returns all available results that match.   You can use &gt;10 to search for all wholesaleTax1s greater than 10. You can use [1,2,3] to search for wholesaleTax1s that match either 1, 2 or 3. You can use this parameter multiple times. eg wholesaleTax1&#x3D;&gt;5&amp; wholesaleTax1&#x3D;&lt;10 would search for all wholesaleTax1s between 5 and 10.
     * @param wholesaleTax2 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the wholesaleTax2 field and returns all available results that match.   You can use &gt;10 to search for all wholesaleTax2s greater than 10. You can use [1,2,3] to search for wholesaleTax2s that match either 1, 2 or 3. You can use this parameter multiple times. eg wholesaleTax2&#x3D;&gt;5&amp; wholesaleTax2&#x3D;&lt;10 would search for all wholesaleTax2s between 5 and 10.
     * @param wholesaleTax3 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the wholesaleTax3 field and returns all available results that match.   You can use &gt;10 to search for all wholesaleTax3s greater than 10. You can use [1,2,3] to search for wholesaleTax3s that match either 1, 2 or 3. You can use this parameter multiple times. eg wholesaleTax3&#x3D;&gt;5&amp; wholesaleTax3&#x3D;&lt;10 would search for all wholesaleTax3s between 5 and 10.
     * @param salesTax0 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the salesTax0 field and returns all available results that match.   You can use &gt;10 to search for all salesTax0s greater than 10. You can use [1,2,3] to search for salesTax0s that match either 1, 2 or 3. You can use this parameter multiple times. eg salesTax0&#x3D;&gt;5&amp; salesTax0&#x3D;&lt;10 would search for all salesTax0s between 5 and 10.
     * @param salesTax1 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the salesTax1 field and returns all available results that match.   You can use &gt;10 to search for all salesTax1s greater than 10. You can use [1,2,3] to search for salesTax1s that match either 1, 2 or 3. You can use this parameter multiple times. eg salesTax1&#x3D;&gt;5&amp; salesTax1&#x3D;&lt;10 would search for all salesTax1s between 5 and 10.
     * @param salesTax2 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the salesTax2 field and returns all available results that match.   You can use &gt;10 to search for all salesTax2s greater than 10. You can use [1,2,3] to search for salesTax2s that match either 1, 2 or 3. You can use this parameter multiple times. eg salesTax2&#x3D;&gt;5&amp; salesTax2&#x3D;&lt;10 would search for all salesTax2s between 5 and 10.
     * @param salesTax3 &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the salesTax3 field and returns all available results that match.   You can use &gt;10 to search for all salesTax3s greater than 10. You can use [1,2,3] to search for salesTax3s that match either 1, 2 or 3. You can use this parameter multiple times. eg salesTax3&#x3D;&gt;5&amp; salesTax3&#x3D;&lt;10 would search for all salesTax3s between 5 and 10.
     * @param qtyTaxFree &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyTaxFree field and returns all available results that match.   You can use &gt;10 to search for all qtyTaxFrees greater than 10. You can use [1,2,3] to search for qtyTaxFrees that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyTaxFree&#x3D;&gt;5&amp; qtyTaxFree&#x3D;&lt;10 would search for all qtyTaxFrees between 5 and 10.
     * @param isSalesTaxCumulative &lt;br&gt;&lt;b&gt;boolean:&lt;/b&gt;
     * @param name &lt;br&gt;This parameter searches for the name field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param code &lt;br&gt;This parameter searches for the code field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, taxRateId?: number, wholesaleTax0?: string, wholesaleTax1?: string, wholesaleTax2?: string, wholesaleTax3?: string, salesTax0?: string, salesTax1?: string, salesTax2?: string, salesTax3?: string, qtyTaxFree?: string, isSalesTaxCumulative?: string, name?: string, code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, organisationId?: string, externalKey?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaxRateView>>;
    public taxRatesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, taxRateId?: number, wholesaleTax0?: string, wholesaleTax1?: string, wholesaleTax2?: string, wholesaleTax3?: string, salesTax0?: string, salesTax1?: string, salesTax2?: string, salesTax3?: string, qtyTaxFree?: string, isSalesTaxCumulative?: string, name?: string, code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, organisationId?: string, externalKey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaxRateView>>>;
    public taxRatesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, taxRateId?: number, wholesaleTax0?: string, wholesaleTax1?: string, wholesaleTax2?: string, wholesaleTax3?: string, salesTax0?: string, salesTax1?: string, salesTax2?: string, salesTax3?: string, qtyTaxFree?: string, isSalesTaxCumulative?: string, name?: string, code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, organisationId?: string, externalKey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaxRateView>>>;
    public taxRatesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, taxRateId?: number, wholesaleTax0?: string, wholesaleTax1?: string, wholesaleTax2?: string, wholesaleTax3?: string, salesTax0?: string, salesTax1?: string, salesTax2?: string, salesTax3?: string, qtyTaxFree?: string, isSalesTaxCumulative?: string, name?: string, code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, organisationId?: string, externalKey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (taxRateId !== undefined && taxRateId !== null) {
            queryParameters = queryParameters.set('taxRateId', <any>taxRateId);
        }
        if (wholesaleTax0 !== undefined && wholesaleTax0 !== null) {
            queryParameters = queryParameters.set('wholesaleTax0', <any>wholesaleTax0);
        }
        if (wholesaleTax1 !== undefined && wholesaleTax1 !== null) {
            queryParameters = queryParameters.set('wholesaleTax1', <any>wholesaleTax1);
        }
        if (wholesaleTax2 !== undefined && wholesaleTax2 !== null) {
            queryParameters = queryParameters.set('wholesaleTax2', <any>wholesaleTax2);
        }
        if (wholesaleTax3 !== undefined && wholesaleTax3 !== null) {
            queryParameters = queryParameters.set('wholesaleTax3', <any>wholesaleTax3);
        }
        if (salesTax0 !== undefined && salesTax0 !== null) {
            queryParameters = queryParameters.set('salesTax0', <any>salesTax0);
        }
        if (salesTax1 !== undefined && salesTax1 !== null) {
            queryParameters = queryParameters.set('salesTax1', <any>salesTax1);
        }
        if (salesTax2 !== undefined && salesTax2 !== null) {
            queryParameters = queryParameters.set('salesTax2', <any>salesTax2);
        }
        if (salesTax3 !== undefined && salesTax3 !== null) {
            queryParameters = queryParameters.set('salesTax3', <any>salesTax3);
        }
        if (qtyTaxFree !== undefined && qtyTaxFree !== null) {
            queryParameters = queryParameters.set('qtyTaxFree', <any>qtyTaxFree);
        }
        if (isSalesTaxCumulative !== undefined && isSalesTaxCumulative !== null) {
            queryParameters = queryParameters.set('isSalesTaxCumulative', <any>isSalesTaxCumulative);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TaxRateView>>('get',`${this.basePath}/TaxRates/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public taxRatesIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public taxRatesIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public taxRatesIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/TaxRates/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_taxrates
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesIdGet(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<TaxRateView>;
    public taxRatesIdGet(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaxRateView>>;
    public taxRatesIdGet(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaxRateView>>;
    public taxRatesIdGet(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesIdGet.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TaxRateView>('get',`${this.basePath}/TaxRates/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a TaxRate object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesIdPut(id: number, body?: TaxRateUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaxRateView>>;
    public taxRatesIdPut(id: number, body?: TaxRateUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaxRateView>>>;
    public taxRatesIdPut(id: number, body?: TaxRateUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaxRateView>>>;
    public taxRatesIdPut(id: number, body?: TaxRateUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling taxRatesIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TaxRateView>>('put',`${this.basePath}/TaxRates/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new TaxRate&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_taxrates&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_taxrates&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_taxrates_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taxRatesPost(body?: TaxRateInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<TaxRateView>;
    public taxRatesPost(body?: TaxRateInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaxRateView>>;
    public taxRatesPost(body?: TaxRateInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaxRateView>>;
    public taxRatesPost(body?: TaxRateInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaxRateView>('post',`${this.basePath}/TaxRates/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
